import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { DropDown, SimpleCross } from "../../assets/icons";
import ButtonLoader from "../../atoms/buttonLoader";
import { getWorkersData, AllocateProject } from "../../services/service";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const AssignWorkerBar = ({ visible, onClose, projectId, refreshWorkers }) => {
  const { Option } = Select;
  const [isLoading, setIsLoading] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [workersLoading, setWorkersLoading] = useState(false);

  const handleGetWorkers = async () => {
    setWorkersLoading(true);
    try {
      const response = await getWorkersData("", 1000, 1, "");
      if (response?.success) {
        setWorkers(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching workers data:", error);
    } finally {
      setWorkersLoading(false);
    }
  };

  useEffect(() => {
    handleGetWorkers();
  }, []);


  const formik = useFormik({
    initialValues: {
      worker: "",
    },
    validationSchema: Yup.object({
      worker: Yup.string().required("Worker is required"),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setFieldTouched }) => {
      if (!values.worker) {
        return;
      }
      
      setIsLoading(true);
      const data = {
        user_id: values.worker,
        project_id: projectId,
      };
      try {
        const response = await AllocateProject(data);
        if (response?.success) {
          if (refreshWorkers) {
            await refreshWorkers();
          }
          onClose();
          toast.success("Project allocated successfully!");
        } else {
          console.error("Error in API response:", response?.message);
          toast.error("Project allocation already exists");
        }
      } catch (error) {
        console.error("Error assigning worker:", error);
        toast.error(
          error?.response?.data?.message || "Project allocation already exists"
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  if (!visible) return null;

  return (
    <div className="fixed top-0 right-0 w-[400px] h-full bg-white shadow-lg z-50" onClick={onClose}>
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="absolute top-0 right-0 w-[400px] h-full bg-white shadow-lg" onClick={(e) => e.stopPropagation()}>
      <div className="flex justify-between items-center p-4">
        <h2 className="text-[20px] font-semibold text-[#1E3A8A]">
          Assign Worker
        </h2>
        <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>
          {SimpleCross}
        </button>
      </div>
      <div className="p-4 -mt-5">
        <form onSubmit={formik.handleSubmit}>
          <Select
            placeholder="Select Worker"
            className={`w-full h-[52px] rounded-[4px] border 
      border-[#E9E9E9]
   focus:outline-none mb-4`}
            allowClear={false}
            suffixIcon={DropDown}
            value={formik.values.worker || undefined}
            onChange={(value) => formik.setFieldValue("worker", value)}
            loading={workersLoading}
          >
            {workers?.map((worker) => (
              <Option key={worker.id} value={worker.id}>
                {worker.username}
              </Option>
            ))}
          </Select>

          {formik.errors.worker && formik.touched.worker && (
            <div className="text-red-500 text-sm mb-4">
              {formik.errors.worker}
            </div>
          )}
          <div className="flex gap-4">
            <button
              type="submit"
              className="bg-[#F97316] hover:bg-orange-600 text-white py-2 px-4 rounded"
              disabled={isLoading}
            >
              {isLoading ? <ButtonLoader /> : "Assign Worker"}
            </button>
          </div>
        </form>
      </div>
      </div>
    </div>
  );
};

export default AssignWorkerBar;
